import { render, staticRenderFns } from "./HomePosts.vue?vue&type=template&id=4a84c300&scoped=true&"
import script from "./HomePosts.vue?vue&type=script&lang=js&"
export * from "./HomePosts.vue?vue&type=script&lang=js&"
import style0 from "./HomePosts.vue?vue&type=style&index=0&id=4a84c300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a84c300",
  null
  
)

export default component.exports